import React, { useState } from "react";
import bg from "assets/bg.png";
import logo from "assets/logo.png";

function Logo(props) {

  return (
    <div className="container logoContainer">
      <div className="columns">
          <div className="column">
              <img src={logo} />
          </div>
      </div>
    </div>
  );
}

export default Logo;
